import React, { useState } from 'react';
import styles from '../Steps.module.scss';
import ProgramCourse from '../ProgramCourse';
import ApplicantsTab from '../../../Atoms/Tabs/ApplicantsTab';

const ProgramSecondStep = ({
  degreeCurriculumDetails,
  isLoading,
  refetchProgram,
}) => {
  const [selected, setSelected] = useState(0);
const tabs = [
  { index: 0, name: 'first-year', text: 'السنة الأولى' },
  { index: 1, name: 'second-year', text: 'السنة الثانية' },
  { index: 2, name: 'third-year', text: 'السنة الثالثة' },
  { index: 3, name: 'fourth-year', text: 'السنة الرابعة' },
  { index: 4, name: 'fifth-year', text: 'السنة الخامسة' },
];


  const firstYearDetails = degreeCurriculumDetails?.filter(
    (detail) => detail.year === 0
  );
  const secondYearDetails = degreeCurriculumDetails?.filter(
    (detail) => detail.year === 1
  );
  const thirdYearDetails = degreeCurriculumDetails?.filter(
    (detail) => detail.year === 2
  );
  const fourthYearDetails = degreeCurriculumDetails?.filter(
    (detail) => detail.year === 3
  );

  const fifthYearDetails = degreeCurriculumDetails?.filter(
    (detail) => detail.year === 4
  );

  let detailsToShow;
  switch (selected) {
    case 0:
      detailsToShow = firstYearDetails;
      break;
    case 1:
      detailsToShow = secondYearDetails;
      break;
    case 2:
      detailsToShow = thirdYearDetails;
      break;
    case 3:
      detailsToShow = fourthYearDetails;
      break;
    case 4:
      detailsToShow = fifthYearDetails;
      break;
    default:
      detailsToShow = [];
  }

  return (
    <div>
      <div className={styles['tab-container']}>
        {tabs.map((tab) => (
          <ApplicantsTab
            key={tab.index}
            text={tab.text}
            handleOnClick={() => {
              setSelected(tab.index);
            }}
            active={tab.index === selected ? true : false}
            shadowed={false}
          />
        ))}
      </div>
      <div>
        <ProgramCourse
          detailsToShow={detailsToShow}
          isLoading={isLoading}
          refetchProgram={refetchProgram}
          selectedYear={selected}
        />
      </div>
    </div>
  );
};

export default ProgramSecondStep;
